import { ApolloClient, from, HttpLink, InMemoryCache } from "@apollo/client";
import { API_ENNDPOINT } from "./consts";
import { setContext } from "@apollo/link-context";
import Store from "./Redux/Store";
import { GraphQLError } from "graphql";
import { onError } from "@apollo/client/link/error";
import { AUTHENTICATED } from "./Redux/Auth/Types";
import { dispatchLogout } from "./Redux/Auth/Logout";

const httpLink = new HttpLink({
  uri: API_ENNDPOINT,
});

const authLink = setContext(() => {
  const authState = Store.getState().auth;
  if (authState.type === AUTHENTICATED) {
    return {
      headers: {
        authorization: `Bearer ${authState.api_key}`,
      },
    };
  }
  return {};
});

function authenticationRequired(errors?: ReadonlyArray<GraphQLError>): boolean {
  if (!errors) return false;
  return errors.filter((error) => error.extensions?.code === 401).length > 0;
}

const logoutLink = onError(({ graphQLErrors, response }) => {
  if (authenticationRequired(graphQLErrors)) {
    dispatchLogout(Store.dispatch);
    if (response) response.errors = undefined;
  }
});

export default new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authLink, logoutLink, httpLink]),
});
